"use client";

import React from "react";
import { ShieldCheck, TrendingUp, BrainCircuit } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const philosophyPoints = [{
  icon: BrainCircuit,
  title: "Wiedza i Doświadczenie",
  description: "Nasz zespół to wykwalifikowani prawnicy specjalizujący się w skomplikowanych sprawach odszkodowawczych i zadośćuczynieniach."
}, {
  icon: ShieldCheck,
  title: "Pełne Bezpieczeństwo",
  description: "Gwarantujemy przejrzyste zasady współpracy i rzetelną reprezentację przed ubezpieczycielami oraz organami sądowymi."
}, {
  icon: TrendingUp,
  title: "Skuteczne Działanie",
  description: "Koncentrujemy się na uzyskaniu najwyższych możliwych kwot odszkodowań, wspierając klientów na każdym etapie procesu."
}];
export default function About() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="6310" id="aboutus" ref={sectionRef} className="relative w-full py-24 bg-background overflow-hidden">
      {}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-secondary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {}
          <div className={`flex flex-col gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <h2 className="font-display font-bold text-foreground tracking-tight !text-[34px]">Pomoc prawna w sprawach odszkodowawczych</h2>
              <div className="w-20 h-1 bg-primary/40 rounded-full" />
            </div>

            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed font-serif">
              <p>
                Zgłaszają się do nas osoby, które brały udział w wypadku, doznały szkody osobowej lub straciły osobę bliską i nie wiedzą, jakie roszczenia im przysługują. Każdą sprawę analizujemy indywidualnie, rzetelnie oceniając odpowiedzialność sprawcy oraz podstawy prawne dochodzenia należnych świadczeń.
              </p>
              <p>
                Zapewniamy profesjonalną obsługę prawną na etapie przedsądowym oraz sądowym. Działamy na terenie Słupska i okolic, oferując możliwość współpracy zdalnej oraz kontakt osobisty, zawsze kierując się empatią wobec poszkodowanych i dbałością o ich interesy w starciu z towarzystwami ubezpieczeniowymi.
              </p>
            </div>
          </div>

          {}
          <div className={`transition-all duration-700 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Card className="bg-white/80 backdrop-blur-md border border-primary/10 shadow-soft hover:shadow-medium transition-shadow duration-300 overflow-hidden">
              <CardContent className="p-8 md:p-10 space-y-8">
                {philosophyPoints.map((point, index) => <div key={index} data-index={index} className="flex gap-5 items-start group">
                    <div className="shrink-0 p-3 rounded-lg bg-primary-light text-primary group-hover:bg-primary group-hover:text-foreground-primary transition-colors duration-300">
                      <point.icon className="w-6 h-6" />
                    </div>
                    <div className="space-y-2">
                      <h3 className="text-xl font-display font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                        {point.title}
                      </h3>
                      <p className="text-muted-foreground text-sm leading-relaxed font-serif">
                        {point.description}
                      </p>
                    </div>
                  </div>)}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}